export default __webpack_public_path__ + "static/media/gh.f1d457d3.svg";